"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteDataStatus = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var react_transition_group_1 = require("react-transition-group");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var RemoteDataStatus;
(function (RemoteDataStatus) {
    RemoteDataStatus["NotRequested"] = "notRequested";
    RemoteDataStatus["Loading"] = "loading";
    RemoteDataStatus["Success"] = "success";
    RemoteDataStatus["Error"] = "error";
})(RemoteDataStatus || (exports.RemoteDataStatus = RemoteDataStatus = {}));
var LegacyCombobox = (function (_super) {
    __extends(LegacyCombobox, _super);
    function LegacyCombobox(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.selectedValue = null;
        _this.selectedElemRef = react_1.default.createRef();
        _this.isFocused = false;
        _this.inputWidth = 0;
        _this.textInputRef = react_1.default.createRef();
        _this.entries = { status: RemoteDataStatus.NotRequested };
        _this.getIdForEntry = function (entryValue) {
            return "comboboxentry".concat(entryValue.toLowerCase().replace(/[^a-z0-9]/, ""));
        };
        _this.setInputWidth = function () {
            var _a;
            _this.inputWidth = ((_a = _this.textInputRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
        };
        _this.handleSelect = function (entry) {
            _this.props.onSelect(entry);
            if (_this.props.clearOnSelect) {
                _this.searchTerm = "";
                _this.displayOnlyTerm = "";
                _this.selectedValue = null;
            }
        };
        _this.onKeyDown = function (event) {
            var _a, _b, _c, _d;
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            switch (event.key) {
                case utils_1.KeyType.ArrowDown:
                    var nextItem = _this.getNextItem();
                    if (nextItem) {
                        _this.selectedValue = nextItem.value;
                        _this.displayOnlyTerm = nextItem.label;
                        setTimeout(function () {
                            var _a;
                            (_a = _this.selectedElemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                                block: "center",
                            });
                        });
                    }
                    event.preventDefault();
                    break;
                case utils_1.KeyType.ArrowUp:
                    var previousItem = _this.getPreviousItem();
                    if (previousItem) {
                        _this.selectedValue = previousItem.value;
                        _this.displayOnlyTerm = previousItem.label;
                        setTimeout(function () {
                            var _a;
                            (_a = _this.selectedElemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                                block: "center",
                            });
                        });
                    }
                    event.preventDefault();
                    break;
                case utils_1.KeyType.Enter:
                    if (_this.entries.status !== RemoteDataStatus.Success) {
                        return;
                    }
                    var index = _this.entries.data.findIndex(function (entry) {
                        if (_this.selectedValue) {
                            return entry.value === _this.selectedValue;
                        }
                        return entry.label === (_this.displayOnlyTerm || _this.searchTerm);
                    });
                    if (index >= 0) {
                        _this.handleSelect(_this.entries.data[index]);
                    }
                    (_a = _this.textInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    event.preventDefault();
                    break;
                case utils_1.KeyType.Escape:
                    event.preventDefault();
                    (_b = _this.textInputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                    (_d = (_c = _this.props).onCancel) === null || _d === void 0 ? void 0 : _d.call(_c);
                    break;
            }
        };
        _this.getNextItem = function () {
            if (_this.entries.status !== RemoteDataStatus.Success) {
                return null;
            }
            var index = _this.entries.data.findIndex(function (entry) {
                return entry.value === _this.selectedValue;
            });
            if (index + 1 >= _this.entries.data.length) {
                return _this.entries.data[0];
            }
            else {
                return _this.entries.data[index + 1];
            }
        };
        _this.getPreviousItem = function () {
            if (_this.entries.status !== RemoteDataStatus.Success) {
                return null;
            }
            var index = _this.entries.data.findIndex(function (entry) {
                return entry.value === _this.selectedValue;
            });
            if (index - 1 < 0) {
                return _this.entries.data[_this.entries.data.length - 1];
            }
            else {
                return _this.entries.data[index - 1];
            }
        };
        _this.onFocus = function () {
            _this.filterEntries();
            _this.isFocused = true;
        };
        _this.onBlur = function () {
            _this.isFocused = false;
        };
        _this.filterEntries = function () {
            if (_this.props.entries instanceof Function) {
                _this.setEntries({ status: RemoteDataStatus.Loading });
                _this.debouncedFetchEntries(_this.props.entries);
            }
            else {
                _this.setEntries({
                    status: RemoteDataStatus.Success,
                    data: _this.props.entries.filter(function (entry) {
                        if (!!_this.props.onFilter) {
                            return _this.props.onFilter(entry, _this.searchTerm);
                        }
                        else if (_this.searchTerm === "") {
                            return true;
                        }
                        else {
                            return entry.label.toLowerCase().indexOf(_this.searchTerm.toLowerCase()) >= 0;
                        }
                    }),
                });
            }
        };
        _this.fetchEntries = function (fetch) { return __awaiter(_this, void 0, Promise, function () {
            var result, entries, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = fetch(this.searchTerm);
                        if (!(result instanceof Promise)) return [3, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, result];
                    case 2:
                        entries = _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setEntries({
                            status: RemoteDataStatus.Error,
                            error: new Error("Something went wrong. Please try again."),
                        });
                        return [2];
                    case 4: return [3, 6];
                    case 5:
                        entries = result;
                        _a.label = 6;
                    case 6:
                        this.setEntries({
                            status: RemoteDataStatus.Success,
                            data: entries,
                        });
                        return [2];
                }
            });
        }); };
        _this.debouncedFetchEntries = (0, lodash_1.debounce)(_this.fetchEntries, 500);
        _this.searchTerm = (_a = props.startingSearchTerm) !== null && _a !== void 0 ? _a : "";
        _this.comboListDomId = "combobox".concat((0, utils_1.randomString)().toLowerCase());
        return _this;
    }
    LegacyCombobox.prototype.componentDidMount = function () {
        var _this = this;
        this.setInputWidth();
        var isShowing = false;
        if (this.props.autoFocus) {
            isShowing = true;
            setTimeout(function () {
                if (_this.textInputRef.current != null) {
                    _this.textInputRef.current.focus();
                }
            });
        }
        if (this.props.autoSelect) {
            isShowing = true;
            setTimeout(function () {
                if (_this.textInputRef.current != null) {
                    _this.textInputRef.current.select();
                }
            });
        }
        if (isShowing) {
            this.filterEntries();
        }
    };
    LegacyCombobox.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(ComboboxWrapper, { className: (0, classnames_1.default)("legacy-combobox", "legacy-combobox--".concat(this.props.theme)), useWrapper: !this.props.renderInput },
            react_1.default.createElement(withPolyfill_1.default, { handleWidth: true, onResize: this.setInputWidth }, this.renderComboboxInput()),
            react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: this.isFocused, timeout: kaleidoscope_1.AnimationDuration.Long, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                var _a;
                return (react_1.default.createElement(ComboboxListBox, { noEntriesMessage: _this.searchTerm.length > 0 ? _this.props.noResultsMessage : _this.props.noEntriesMessage, renderNoEntriesMessage: _this.searchTerm.length > 0 ? function () { var _a, _b; return (_b = (_a = _this.props).renderNoResultsMessage) === null || _b === void 0 ? void 0 : _b.call(_a, _this.searchTerm); } : undefined, entries: _this.entries, handleSelect: _this.handleSelect, getIdForEntry: _this.getIdForEntry, textInputRef: _this.textInputRef, selectedElemRef: _this.selectedElemRef, selectedValue: _this.selectedValue, theme: _this.props.theme, renderEntry: _this.props.renderEntry, isFocused: _this.isFocused, comboListDomId: _this.comboListDomId, className: _this.props.className, transitionStatus: status, listWidth: _this.inputWidth, listEndElement: _this.props.listEndElement, autoStack: (_a = _this.props.autoStack) !== null && _a !== void 0 ? _a : false }));
            })); })));
    };
    LegacyCombobox.prototype.renderComboboxInput = function () {
        var _this = this;
        var commonInputProps = {
            placeholder: this.props.placeholder,
            value: this.displayOnlyTerm || this.searchTerm,
            ref: this.textInputRef,
            role: "combobox",
            "aria-expanded": this.isFocused ? "true" : "false",
            "aria-required": "true",
            "aria-activedescendant": this.isFocused && this.selectedValue ? this.getIdForEntry(this.selectedValue) : undefined,
            "aria-controls": this.isFocused ? this.comboListDomId : undefined,
            "aria-autocomplete": "list",
            onChange: function (value) {
                _this.searchTerm = value;
                _this.displayOnlyTerm = "";
                _this.selectedValue = null;
                _this.filterEntries();
                if (_this.props.onChange) {
                    _this.props.onChange(_this.searchTerm);
                }
            },
            onKeyDown: this.onKeyDown,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            disabled: this.props.disabled,
        };
        if (!!this.props.renderInput) {
            return this.props.renderInput(commonInputProps);
        }
        else {
            return (react_1.default.createElement(kaleidoscope_1.SearchInput, __assign({}, commonInputProps, { label: this.props.label, theme: this.props.theme || kaleidoscope_1.TextInputTheme.Dark, variant: this.props.variant, size: this.props.size, startElement: this.props.startElement, endElement: this.props.endElement })));
        }
    };
    LegacyCombobox.prototype.setEntries = function (entries) {
        this.entries = entries;
    };
    LegacyCombobox.defaultProps = {
        autoFocus: false,
        autoSelect: false,
        clearOnSelect: false,
        noEntriesMessage: "No items available",
        noResultsMessage: "No results found",
        variant: kaleidoscope_1.TextInputVariant.Bordered,
        size: kaleidoscope_1.TextInputSize.Medium,
        theme: kaleidoscope_1.TextInputTheme.Light,
        disabled: false,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LegacyCombobox.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "displayOnlyTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "selectedValue", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "isFocused", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "inputWidth", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "entries", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "setInputWidth", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "onFocus", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LegacyCombobox.prototype, "onBlur", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], LegacyCombobox.prototype, "setEntries", null);
    LegacyCombobox = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], LegacyCombobox);
    return LegacyCombobox;
}(react_1.default.Component));
exports.default = LegacyCombobox;
var ComboboxWrapper = function (props) {
    var className = props.className, useWrapper = props.useWrapper, children = props.children;
    if (useWrapper) {
        return react_1.default.createElement("div", { className: className }, children);
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
};
var ComboboxListBox = (function (_super) {
    __extends(ComboboxListBox, _super);
    function ComboboxListBox() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.portalRoot = (0, utils_1.getPortalRoot)("combobox-root");
        _this.listRef = react_1.default.createRef();
        _this.hasMadeSelection = false;
        _this.handleRectObserver = function (targetRect) {
            var _a;
            var listRect = (_a = _this.listRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            _this.listPosition = (0, utils_1.getOverlayPosition)({
                targetRect: targetRect,
                overlayRect: listRect,
                position: "bottom",
                offset: 8,
                outerMargin: 8,
            });
        };
        _this.renderEntry = function (entry) {
            if (_this.props.renderEntry != null) {
                return _this.props.renderEntry(entry);
            }
            else {
                return (react_1.default.createElement("span", { className: (0, classnames_1.default)("legacy-combobox__default-entry-label", "legacy-combobox__default-entry-label--".concat(_this.props.theme)) }, entry.label));
            }
        };
        _this.renderPanelContent = function () {
            switch (_this.props.entries.status) {
                case RemoteDataStatus.NotRequested:
                case RemoteDataStatus.Loading:
                    return react_1.default.createElement(kaleidoscope_1.Spinner, { className: "space-inset-l", primary: true });
                case RemoteDataStatus.Error:
                    return react_1.default.createElement("div", { className: "legacy-combobox__message" }, _this.props.entries.error.message);
                case RemoteDataStatus.Success:
                    return _this.renderList(_this.props.entries.data);
                default:
                    throw new Error("Unknown Combobox Entries status");
            }
        };
        return _this;
    }
    ComboboxListBox.prototype.componentDidMount = function () {
        var _a;
        this.rectObserver = (0, observe_rect_1.default)(this.props.textInputRef.current, this.handleRectObserver);
        (_a = this.rectObserver) === null || _a === void 0 ? void 0 : _a.observe();
    };
    ComboboxListBox.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.textInputRef.current && prevProps.listWidth !== this.props.listWidth) {
            this.handleRectObserver(this.props.textInputRef.current.getBoundingClientRect());
        }
    };
    ComboboxListBox.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.rectObserver) === null || _a === void 0 ? void 0 : _a.unobserve();
    };
    ComboboxListBox.prototype.renderList = function (entries) {
        var _this = this;
        var _a, _b;
        if (entries.length < 1) {
            return (((_b = (_a = this.props).renderNoEntriesMessage) === null || _b === void 0 ? void 0 : _b.call(_a)) || (react_1.default.createElement("div", { className: "legacy-combobox__message" }, this.props.noEntriesMessage)));
        }
        return entries.map(function (entry) {
            var isSelected = entry.value === _this.props.selectedValue;
            return (react_1.default.createElement("div", { id: _this.props.getIdForEntry(entry.value), key: entry.value, className: (0, classnames_1.default)("legacy-combobox__entry", "legacy-combobox-entry--".concat(_this.props.theme), {
                    "legacy-combobox__entry--selected": isSelected,
                }), "aria-selected": isSelected ? "true" : "false", role: "option", ref: isSelected ? _this.props.selectedElemRef : null, onMouseDown: function (e) {
                    e.stopPropagation();
                    e.nativeEvent.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    if (!_this.hasMadeSelection && e.button === utils_1.MouseButtonType.Left) {
                        _this.hasMadeSelection = true;
                        _this.props.handleSelect(entry);
                    }
                } }, _this.renderEntry(entry)));
        });
    };
    ComboboxListBox.prototype.render = function () {
        var _this = this;
        return (0, react_dom_1.createPortal)(react_1.default.createElement(utils_1.Layer, null, function (_a) {
            var _b, _c;
            var zIndex = _a.zIndex;
            return (react_1.default.createElement("div", { ref: _this.listRef, className: (0, classnames_1.default)("legacy-combobox__combo-holder", _this.props.className), style: {
                    transform: "translate3d(".concat(((_b = _this.listPosition) === null || _b === void 0 ? void 0 : _b.overlay.left) || 0, "px, ").concat(((_c = _this.listPosition) === null || _c === void 0 ? void 0 : _c.overlay.top) || 0, "px, 0)"),
                    width: _this.props.listWidth,
                    zIndex: _this.props.autoStack ? zIndex : undefined,
                }, onMouseDown: function (e) {
                    e.nativeEvent.stopImmediatePropagation();
                } },
                react_1.default.createElement(kaleidoscope_1.Panel, { className: (0, classnames_1.default)("legacy-combobox__combo", "legacy-combobox__combo--".concat(_this.props.transitionStatus)), id: _this.props.comboListDomId, role: "listbox", theme: _this.props.theme === kaleidoscope_1.TextInputTheme.Dark ? kaleidoscope_1.PanelTheme.Dark : kaleidoscope_1.PanelTheme.Light },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)("legacy-combobox__combo-content", "legacy-combobox__combo-content--".concat(_this.props.theme)) }, _this.renderPanelContent()),
                    _this.props.listEndElement)));
        }), this.portalRoot);
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof utils_1.OverlayPositionProps !== "undefined" && utils_1.OverlayPositionProps) === "function" ? _a : Object)
    ], ComboboxListBox.prototype, "listPosition", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ComboboxListBox.prototype, "hasMadeSelection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ComboboxListBox.prototype, "handleRectObserver", void 0);
    ComboboxListBox = __decorate([
        mobx_react_1.observer
    ], ComboboxListBox);
    return ComboboxListBox;
}(react_1.default.Component));
